import { Box } from '@mui/material';

interface SettingsLayoutProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
}

export const SettingsLayout = ({ sidebar, children }: SettingsLayoutProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 2, md: 3 },
      }}
    >
      {/* Sidebar — hidden on mobile (FAB + Drawer inside SettingsSidebar handles mobile) */}
      <Box
        sx={{
          display: { xs: 'none', md: 'block' },
          width: 280,
          flexShrink: 0,
        }}
      >
        <Box
          sx={{
            position: 'sticky',
            top: 16,
            maxHeight: 'calc(100vh - 32px)',
            overflowY: 'auto',
          }}
        >
          {sidebar}
        </Box>
      </Box>

      {/* Content area */}
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {children}
      </Box>
    </Box>
  );
};
